import { Component, ViewChild } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { Table } from 'primeng/table';
import { DocumentService } from 'src/app/core/services/document.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})
export class DocumentsComponent {

  breadCrumbItems: Array<{}>;
  documents: any[] = [];
  documentDetail: any = {}

  loading = false;
  showModal = false;
  error = '';
  successMessage = '';

  currentPage = 1;
  pageSize = 10;
  totalPages = 0;
  @ViewChild('dt') table!: Table;


  constructor(private documentService: DocumentService) { }

  ngOnInit() {
    this.breadCrumbItems = [{ label: 'AVSS eSign' }, { label: 'Documents', active: true }];
  }

  getDocuments(event: LazyLoadEvent) {
    setTimeout(() => {
      this.loading = true;
    });

    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams: any = {
      page: page,
      limit: rows,
      search: this.searchText,
      status: this.selectedStatus,
      startDate: startDate,
      endDate: endDate
    };

    this.documentService.getAllDocument(queryParams).subscribe(
      (res: any) => {
        this.documents = res?.data;
        this.totalRecords = res?.totalCount || 0;
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }


  getDocument(doc: any) {
    const id = doc?._id
    this.documentService.getDocumentDetail(id).subscribe((doc: any) => {
      this.showModal = true;
      this.documentDetail = doc;
    }, () => { });
  }


  closeModal() {
    this.showModal = false;
  }

  getUserStatus(users: any[] = []): number {
    if (!users || users.length === 0) {
      return 0;
    }

    const signedCount = users.filter(
      u => u.status?.toLowerCase() === 'signed'
    ).length;

    const percentage = (signedCount / users.length) * 100;
    return Math.round(percentage);
  }

  totalRecords = 0;
  rows = 10;
  searchText = '';
  selectedStatus: string = '';
  rangeDates: Date[] | null = null;

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Signed', value: 'Signed' },
  ];

  onStatusChange(table: any) {
    table.reset();
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  filterChange(event) {
    this.selectedStatus = event.status;
    this.searchText = event.search;
    this.rangeDates = event.dateRange
    this.table?.reset();
  }
}
